var path = 'app/scripts/modules/azure/src/serverGroup/configure/wizard/tags/tags.html';
var html = "<ng-form name=\"zonesSubForm\">\n  <div class=\"container-fluid form-horizontal\">\n    <azure-tags-selector command=\"command\"></azure-tags-selector>\n  </div>\n</ng-form>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;